export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-slate-100 dark:bg-slate-900 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-white dark:bg-slate-800 rounded-3xl shadow-xl p-6 md:p-10">
        <h1 className="text-2xl md:text-3xl font-bold text-slate-800 dark:text-slate-100 mb-6">
          Политика обработки персональных данных
        </h1>
        
        <div className="space-y-6 text-slate-700 dark:text-slate-300 text-sm md:text-base leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">1. Общие положения</h2>
            <p>
              Настоящая Политика обработки персональных данных (далее — «Политика») определяет порядок сбора, хранения, 
              обработки и защиты персональных данных пользователей сервиса Travel Ease (далее — «Сервис»).
            </p>
            <p className="mt-2">
              Используя Сервис, вы подтверждаете своё согласие с настоящей Политикой. Если вы не согласны с условиями 
              Политики, пожалуйста, воздержитесь от использования Сервиса.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">2. Собираемые данные</h2>
            <p>В процессе использования Сервиса мы собираем следующие категории персональных данных:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Учётные данные:</strong> имя пользователя, адрес электронной почты, логин для входа в систему</li>
              <li><strong>Профильные данные:</strong> фотография профиля (аватар), принадлежность к организации</li>
              <li><strong>Контактные данные клиентов:</strong> имена, фамилии, номера телефонов, email-адреса, мессенджеры (Telegram, WhatsApp) ваших контактов</li>
              <li><strong>Данные переписки:</strong> текстовые сообщения в чатах между пользователями Сервиса</li>
              <li><strong>Файлы:</strong> загруженные документы, изображения и другие файлы, прикреплённые к контактам или отправленные в чатах</li>
              <li><strong>Финансовые данные:</strong> информация о транзакциях в модуле аналитики</li>
              <li><strong>Данные о задачах:</strong> созданные задачи, комментарии к ним, сроки выполнения</li>
              <li><strong>Обращения в поддержку:</strong> тикеты, описания проблем и комментарии</li>
              <li><strong>Данные о подборе туров:</strong> параметры поиска туров (направления, даты, бюджет)</li>
              <li><strong>Технические данные:</strong> информация о статусе онлайн, время последнего посещения</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">3. Цели обработки данных</h2>
            <p>Персональные данные обрабатываются для следующих целей:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Предоставление доступа к функциям Сервиса и обеспечение его работоспособности</li>
              <li>Идентификация и аутентификация пользователей</li>
              <li>Обеспечение коммуникации между пользователями через встроенный чат</li>
              <li>Хранение и организация клиентской базы контактов</li>
              <li>Формирование аналитических отчётов и статистики</li>
              <li>Управление задачами и рабочими процессами</li>
              <li>Техническая поддержка пользователей</li>
              <li>Подбор туристических предложений по заданным параметрам</li>
              <li>Обеспечение безопасности и предотвращение несанкционированного доступа</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">4. Шифрование и защита данных</h2>
            <p>
              Для обеспечения конфиденциальности применяются следующие меры защиты:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Шифрование переписки:</strong> личные сообщения в чатах защищены шифрованием. Пользователи могут включить сквозное шифрование (E2E) для максимальной защиты</li>
              <li><strong>Шифрование контактных данных:</strong> персональные данные контактов (имена, телефоны, email) хранятся в зашифрованном виде в базе данных</li>
              <li><strong>Защищённое соединение:</strong> все данные передаются по защищённому протоколу HTTPS</li>
              <li><strong>Контроль доступа:</strong> применяется система ролей и разграничения прав доступа (RLS)</li>
              <li><strong>Изоляция данных:</strong> каждый пользователь имеет доступ только к своим данным и данным своей организации</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">5. Хранение данных</h2>
            <p>
              Персональные данные хранятся на защищённых серверах с применением современных технологий безопасности. 
              Срок хранения данных определяется периодом использования Сервиса и требованиями действующего законодательства.
            </p>
            <p className="mt-2">
              Данные удаляются по запросу пользователя или при прекращении использования Сервиса, за исключением случаев, 
              когда их хранение требуется по закону.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">6. Передача данных третьим лицам</h2>
            <p>
              Мы не продаём и не передаём персональные данные третьим лицам для маркетинговых целей. 
              Данные могут быть переданы только в следующих случаях:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>С вашего явного согласия</li>
              <li>Для выполнения требований законодательства</li>
              <li>Техническим партнёрам для обеспечения работоспособности Сервиса (хостинг, база данных)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">7. Права пользователей</h2>
            <p>Вы имеете право:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Получить информацию о хранящихся персональных данных</li>
              <li>Изменить или исправить свои данные через настройки профиля</li>
              <li>Запросить удаление персональных данных</li>
              <li>Отозвать согласие на обработку данных</li>
              <li>Обратиться к администратору с вопросами о защите данных</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">8. Файлы cookie</h2>
            <p>
              Сервис использует локальное хранилище браузера (localStorage) для сохранения настроек пользователя, 
              сессионных данных и ключей шифрования. Эти данные хранятся локально на вашем устройстве и не передаются на сервер.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">9. Изменения в Политике</h2>
            <p>
              Мы оставляем за собой право вносить изменения в настоящую Политику. При существенных изменениях 
              пользователи будут уведомлены через интерфейс Сервиса. Продолжение использования Сервиса после 
              внесения изменений означает принятие обновлённой Политики.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">10. Контакты</h2>
            <p>
              По всем вопросам, связанным с обработкой персональных данных, вы можете обратиться к администратору 
              системы через модуль «Поддержка» в личном кабинете.
            </p>
          </section>

          <div className="pt-6 border-t border-slate-200 dark:border-slate-700">
            <p className="text-xs text-slate-500 dark:text-slate-400">
              Дата последнего обновления: {new Date().toLocaleDateString('ru-RU')}
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}